import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/dist/sweetalert2.min.css';
import useBarkodOkuyucu from '../../../hooks/useBarkodOkuyucu';
import { addressedScanChassis, unAddressedScanChassis } from '../../../services/sayim/sayim-api';
import GeriButonu from '../../common/GeriButonu';

const SayimOkutmaEkrani = ({ setCurrentScreen, selectedCount, selectedZone, selectedAddress }) => {
    const [inputValue, setInputValue] = useState('');
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [isBarkodUpdated, setIsBarkodUpdated] = useState(false); // Animasyon için state
    const [isProcessing, setIsProcessing] = useState(false); // API işlemi sırasında loading

    const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);
    const [duplicateChassisInfo, setDuplicateChassisInfo] = useState(null);
    const [pendingChassisData, setPendingChassisData] = useState(null);
    const [nextAddress, setNextAddress] = useState(null);
    const [lastScannedChassis, setLastScannedChassis] = useState(selectedAddress?.last_scanned_chassis || '');
    const [isChassisUpdated, setIsChassisUpdated] = useState(false);
    const [isLastAddress, setIsLastAddress] = useState(false);
    const { barkodDegeri, barkodGecmisi, temizleBarkodDegeri, barkodEkle } = useBarkodOkuyucu(100, isInputFocused, setInputValue);

    // Barkod okuyucudan gelen değeri işle
    useEffect(() => {
        if (barkodDegeri && barkodDegeri.trim()) {
            barcodeIslemleri();
        }
    }, [barkodDegeri]);

    // Yeni sayım başladığında son adres durumunu sıfırla
    useEffect(() => {
        setIsLastAddress(false);
        setNextAddress(null);
    }, [selectedCount, selectedZone, selectedAddress]);





    // Tekrarlı okutma modal'ı için onay
    const handleDuplicateConfirm = async () => {
        setIsDuplicateModalOpen(false);
        if (pendingChassisData) {
            await handleChassisProcess(pendingChassisData.chassisNo, true);
        }
    };

    // Tekrarlı okutma modal'ını kapat
    const handleDuplicateCancel = () => {
        setIsDuplicateModalOpen(false);
        setPendingChassisData(null);
        setDuplicateChassisInfo(null);
    };

    // Şase işleme fonksiyonu
    const handleChassisProcess = async (chassisNo, forceScan = false) => {
        if (isProcessing) return;

        setIsProcessing(true);

        try {
            let response;

            if (selectedCount?.is_address_based === false) {
                // Adressiz sayım
                const countCode = selectedCount.count_code;
                const userId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))

                response = await unAddressedScanChassis(chassisNo, countCode, userId);
            } else {
                // Adresli sayım
                const countCode = selectedCount.count_code;
                const zoneId = selectedZone.zone_id;

                // Konum alanında yazan adres bilgisini kullan
                let currentAddress = selectedAddress;
                if (nextAddress) {
                    // API'den gelen sonraki adres bilgisini kullan
                    currentAddress = {
                        coordinate: nextAddress.address.split('-')[0].slice(0, -1), // Son karakteri çıkar
                        direction: nextAddress.address.split('-')[0].slice(-1), // Son karakter
                        row_number: nextAddress.address.split('-')[1],
                        capacity: nextAddress.capacity
                    };
                }

                const addressCode = currentAddress.coordinate + currentAddress.direction + "-" + currentAddress.row_number;


                if (isLastAddress && addressCode === selectedAddress.coordinate + selectedAddress.direction + "-" + selectedAddress.row_number) {
                    toast.error("Önerilecek adres kalmadığı için işlem yapılamaz. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    return;
                }
                response = await addressedScanChassis(chassisNo, countCode, zoneId, addressCode, forceScan, false);
            }

            // Önce duplicate scan kontrolü yap
            if (response.error === "DUPLICATE_SCAN" && response.data?.duplicate_info) {
                // Adressiz sayımda duplicate scan durumu
                if (selectedCount?.is_address_based === false) {
                    toast.info("Bu şase daha önce okutulmuştur");
                    setInputValue('');
                    return;
                }

                // Adresli sayımda duplicate scan kontrolü
                // Şu anki adres bilgisini al
                let currentAddress = selectedAddress;
                if (nextAddress) {
                    // API'den gelen sonraki adres bilgisini kullan
                    currentAddress = {
                        coordinate: nextAddress.address.split('-')[0].slice(0, -1), // Son karakteri çıkar
                        direction: nextAddress.address.split('-')[0].slice(-1), // Son karakter
                        row_number: nextAddress.address.split('-')[1],
                        capacity: nextAddress.capacity
                    };
                }
                const currentAddressCode = currentAddress.coordinate + currentAddress.direction + "-" + currentAddress.row_number;

                // Duplicate info'daki adres ile şu anki adres aynı mı kontrol et
                if (response.data.duplicate_info.address === currentAddressCode) {
                    // Aynı adres ise modal açma, toast göster ve input'u temizle
                    toast.info(`Bu şase mevcut adresde sayılmıştır.`);
                    setInputValue('');
                    return;
                } else {
                    // Farklı adres ise modal aç
                    setDuplicateChassisInfo(response.data.duplicate_info);
                    setPendingChassisData({ chassisNo, forceScan });
                    setIsDuplicateModalOpen(true);
                    return;
                }
            }

            if (response.success) {
                // Önce scan_result kontrolü yap
                if (response.data?.scan_result === "DUPLICATE_WARNING") {
                    // Tekrarlı okutma durumu
                    setDuplicateChassisInfo(response.data.duplicate_info);
                    setPendingChassisData({ chassisNo, forceScan });
                    setIsDuplicateModalOpen(true);
                    return;
                }

                // Animasyon için state'i güncelle
                setIsBarkodUpdated(true);
                setTimeout(() => setIsBarkodUpdated(false), 1000);

                // Adresli sayımda sonraki adres bilgisini güncelle
                if (selectedCount?.is_address_based !== false) {
                    // Son adres kontrolü - next_address boş ve message'da "son adres" ifadesi varsa
                    if (!response.data?.next_address || response.data.next_address.trim() === '') {
                        // Sonraki adres yoksa null yap
                        setNextAddress(null);

                        // Message'da "son adres" ifadesi varsa kullanıcıya bildir ve işlemi durdur
                        if (response.message && response.message.toLowerCase().includes('son adres')) {
                            setIsLastAddress(true); // Son adres durumunu işaretle
                            try {
                                Swal.fire({
                                    title: '<div style="color: #2c3e50; font-weight: 600; font-size: 18px;"><i class="fa fa-info-circle" style="color: #3498db; margin-right: 8px;"></i>Son Adres</div>',
                                    html: `
                                        <div style="text-align: center; padding: 10px 0;">
                                            <div style="color: #34495e; font-size: 15px; line-height: 1.6; font-weight: 400;">
                                                Bu adres son adres olduğu için işlem yapılamaz. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana <b>GERİ</b> butonuna tıklayarak geçebilirsiniz.
                                            </div>
                                        </div>
                                    `,
                                    showConfirmButton: true,
                                    confirmButtonText: 'Tamam',
                                    confirmButtonColor: '#3498db',
                                    confirmButtonTextColor: '#ffffff',
                                    customClass: {
                                        popup: 'swal2-custom-popup',
                                        confirmButton: 'swal2-custom-confirm'
                                    },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    background: '#ffffff',
                                    backdrop: 'rgba(0, 0, 0, 0.4)'
                                });
                            } catch (error) {
                                console.error("Swal error:", error);
                                toast.info("Bu adres son adres olduğu için işlem yapılamaz. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.");
                            }
                            return; // İşlemi durdur
                        } else {
                            // Normal "önerilecek sıra bitti" durumu
                            try {
                                Swal.fire({
                                    title: '<div style="color: #2c3e50; font-weight: 600; font-size: 18px;"><i class="fa fa-info-circle" style="color: #3498db; margin-right: 8px;"></i>Önerilecek Sıra Bitti</div>',
                                    html: `
                                        <div style="text-align: center; padding: 10px 0;">
                                            <div style="color: #34495e; font-size: 15px; line-height: 1.6; font-weight: 400;">
                                                Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.
                                            </div>
                                        </div>
                                    `,
                                    showConfirmButton: true,
                                    confirmButtonText: 'Tamam',
                                    confirmButtonColor: '#3498db',
                                    confirmButtonTextColor: '#ffffff',
                                    customClass: {
                                        popup: 'swal2-custom-popup',
                                        confirmButton: 'swal2-custom-confirm'
                                    },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    background: '#ffffff',
                                    backdrop: 'rgba(0, 0, 0, 0.4)'
                                });
                            } catch (error) {
                                console.error("Swal error:", error);
                                toast.info("Önerilecek sıra bitti. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.");
                            }
                        }
                    } else {
                        // Sonraki adres varsa güncelle
                        setNextAddress({
                            address: response.data.next_address,
                            capacity: response.data.next_address_capasity
                        });
                    }
                }

                // Son okutulan şase bilgisini güncelle
                if (response.data?.last_scan_sase) {
                    setLastScannedChassis(response.data.last_scan_sase);
                    // Animasyon için state'i güncelle
                    setIsChassisUpdated(true);
                    setTimeout(() => setIsChassisUpdated(false), 1000);
                } else if (response.data?.chassis_no) {
                    // Adressiz sayımda chassis_no kullan
                    setLastScannedChassis(response.data.chassis_no);
                    // Animasyon için state'i güncelle
                    setIsChassisUpdated(true);
                    setTimeout(() => setIsChassisUpdated(false), 1000);
                }

                // Yarım saniye sonra input'u temizle
                setTimeout(() => {
                    setInputValue('');
                }, 500);
            } else {
                // Hata durumlarını kontrol et
                if (response.error === "DUPLICATE_SCAN") {
                    // Bu durum zaten yukarıda handle edildi, buraya gelmemeli
                    return;
                } else if (response.data?.error_details?.scan_result === "INVALID_FORMAT") {
                    toast.error("Şase numarası 17 karakter olmalıdır");
                } else {
                    toast.error(response.message || response.data?.message || 'Şase okutma işlemi başarısız');
                }
            }
        } catch (error) {
            console.error('Şase okutma hatası:', error);
            toast.error(error?.message || 'Şase okutma işlemi başarısız');
        } finally {
            setIsProcessing(false);
            // Barkod değerini temizle
            temizleBarkodDegeri();
        }
    };

    // Mobil cihaz kontrolü
    const isMobileDevice = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    // Geç butonu işlevi
    const handleGec = async () => {
        if (selectedCount?.is_address_based === false) {
            toast.success('Bu adres geçildi');
            return;
        }

        // Adresli sayımda skip işlemi
        try {
            const countCode = selectedCount.count_code;
            const zoneId = selectedZone.zone_id;

            // Konum alanında yazan adres bilgisini kullan
            let currentAddress = selectedAddress;
            if (nextAddress) {
                // API'den gelen sonraki adres bilgisini kullan
                currentAddress = {
                    coordinate: nextAddress.address.split('-')[0].slice(0, -1), // Son karakteri çıkar
                    direction: nextAddress.address.split('-')[0].slice(-1), // Son karakter
                    row_number: nextAddress.address.split('-')[1],
                    capacity: nextAddress.capacity
                };
            }

            const addressCode = currentAddress.coordinate + currentAddress.direction + "-" + currentAddress.row_number;

            const response = await addressedScanChassis("", countCode, zoneId, addressCode, false, true);

            if (response.success) {
                toast.success('Bu adres geçildi');

                // Sonraki adres bilgisini güncelle
                if (!response.data?.next_address || response.data.next_address.trim() === '') {
                    // Sonraki adres yoksa null yap
                    setNextAddress(null);

                    // Message'da "son adres" ifadesi varsa kullanıcıya bildir
                    if (response.message && response.message.toLowerCase().includes('son adres')) {
                        setIsLastAddress(true); // Son adres durumunu işaretle
                        try {
                            Swal.fire({
                                title: '<div style="color: #2c3e50; font-weight: 600; font-size: 18px;"><i class="fa fa-info-circle" style="color: #3498db; margin-right: 8px;"></i>Son Adres</div>',
                                html: `
                                    <div style="text-align: center; padding: 10px 0;">
                                        <div style="color: #34495e; font-size: 15px; line-height: 1.6; font-weight: 400;">
                                            Bu adres son adres olduğu için işlem yapılamaz. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.
                                        </div>
                                    </div>
                                `,
                                showConfirmButton: true,
                                confirmButtonText: 'Tamam',
                                confirmButtonColor: '#3498db',
                                confirmButtonTextColor: '#ffffff',
                                customClass: {
                                    popup: 'swal2-custom-popup',
                                    confirmButton: 'swal2-custom-confirm'
                                },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                background: '#ffffff',
                                backdrop: 'rgba(0, 0, 0, 0.4)'
                            });
                        } catch (error) {
                            console.error("Swal error:", error);
                            toast.info("Bu adres son adres olduğu için işlem yapılamaz. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.");
                        }
                    } else {
                        // Normal "önerilecek sıra bitti" durumu
                        try {
                            Swal.fire({
                                title: '<div style="color: #2c3e50; font-weight: 600; font-size: 18px;"><i class="fa fa-info-circle" style="color: #3498db; margin-right: 8px;"></i>Önerilecek Sıra Bitti</div>',
                                html: `
                                    <div style="text-align: center; padding: 10px 0;">
                                        <div style="color: #34495e; font-size: 15px; line-height: 1.6; font-weight: 400;">
                                            Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.
                                        </div>
                                    </div>
                                `,
                                showConfirmButton: true,
                                confirmButtonText: 'Tamam',
                                confirmButtonColor: '#3498db',
                                confirmButtonTextColor: '#ffffff',
                                customClass: {
                                    popup: 'swal2-custom-popup',
                                    confirmButton: 'swal2-custom-confirm'
                                },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                background: '#ffffff',
                                backdrop: 'rgba(0, 0, 0, 0.4)'
                            });
                        } catch (error) {
                            console.error("Swal error:", error);
                            toast.info("Önerilecek sıra bitti. Yeni Yön, Koordinat veya Bölge seçimi için 2. ekrana geri tıklayarak geçebilirsiniz.");
                        }
                    }
                } else {
                    // Sonraki adres varsa güncelle
                    setNextAddress({
                        address: response.data.next_address,
                        capacity: response.data.next_address_capasity
                    });
                }
            } else {
                toast.error(response.data?.message || 'Adres geçme işlemi başarısız');
            }
        } catch (error) {
            console.error('Adres geçme hatası:', error);
            toast.error('Adres geçme işlemi başarısız');
        }
    };

    // Tuş basma event listener'ı
    useEffect(() => {
        const handleKeyDown = (event) => {

            if (event.key === 'Enter' && isMobileDevice()) {
                // Adressiz sayımda Enter tuşu barkod okutma işlemi yapar
                if (selectedCount?.is_address_based === false) {
                    if (inputValue.trim()) {
                        handleBarkodEkle();
                    }
                }
                // Adresli sayımda Enter tuşu ile "Geç" işlemi kaldırıldı
                // Sadece butona tıklayarak geç yapılabilir
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [inputValue, selectedCount]);

    const barcodeIslemleri = async () => {
        if (isProcessing) return; // Eğer işlem devam ediyorsa yeni işlem başlatma

        const chassisNo = barkodDegeri.trim();

        // Şase numarası tam olarak 17 karakter olmalı
        if (chassisNo.length !== 17) {
            toast.error("Şase numarası tam olarak 17 karakter olmalıdır");
            return;
        }

        // 17 karakter tam şase numarası için direkt işlem
        await handleChassisProcess(chassisNo);
    }

    // Input değişikliği
    const handleInputChange = (e) => {
        setInputValue(e.target.value.toUpperCase().trim());
    };

    // Input focus/blur event handler'ları
    const handleInputFocus = () => {
        setIsInputFocused(true);
    };

    const handleInputBlur = () => {
        // Kısa bir gecikme ile blur işlemini yap
        // Bu sayede Enter tuşu ile barkod ekleme işlemi tamamlanabilir
        setTimeout(() => {
            setIsInputFocused(false);
        }, 100);
    };

    // Enter tuşu ile barkod ekleme
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            // Mobil cihazlarda Enter tuşu document level'da handle ediliyor
            // Bu yüzden input level'da işlem yapmıyoruz
            if (!isMobileDevice()) {
                handleBarkodEkle();
            }
        }
    };

    // Manuel barkod ekleme
    const handleBarkodEkle = async () => {
        if (inputValue.trim() && !isProcessing) {
            const chassisNo = inputValue.trim();

            // Şase numarası tam olarak 17 karakter olmalı
            if (chassisNo.length !== 17) {
                toast.error("Şase numarası tam olarak 17 karakter olmalıdır");
                return;
            }

            // 17 karakter tam şase numarası için direkt işlem
            await handleChassisProcess(chassisNo);
        }
    };

    useEffect(() => {
        if (document.querySelector(".page-main-header")) document.querySelector(".page-main-header").classList.add('open');
        if (document.querySelector(".page-sidebar")) document.querySelector(".page-sidebar").classList.add('open');
    }, []);

    return (
        <>
            <style>
                {`
                    @keyframes pulse {
                        0% { transform: scale(1); }
                        50% { transform: scale(1.15); }
                        100% { transform: scale(1.1); }
                    }
                    
                    @keyframes checkmark {
                        0% { 
                            opacity: 0; 
                            transform: scale(0) rotate(-45deg); 
                        }
                        50% { 
                            opacity: 1; 
                            transform: scale(1.2) rotate(0deg); 
                        }
                        100% { 
                            opacity: 1; 
                            transform: scale(1) rotate(0deg); 
                        }
                    }
                    
                    @keyframes chassisUpdate {
                        0% { 
                            color: #333; 
                            font-weight: 600;
                            transform: scale(1);
                          
                        }
                        50% { 
                            color: green; 
                            font-weight: 600;
                            transform: scale(1.2);
                        }
                        100% { 
                            color: #333; 
                            font-weight: 600;
                            transform: scale(1);
                        }
                    }
                `}
            </style>
            <div className="container-fluid">
                <Row className="justify-content-center">
                    <Col md="12" className='mt-2'>
                        <Card>
                            <CardBody>

                                <GeriButonu onClick={() => setCurrentScreen('zoneSelect')} />

                                {/* Konum Bilgisi */}
                                {selectedCount && (
                                    <div style={{
                                        marginBottom: '20px',
                                        padding: '6px',
                                        backgroundColor: '#f0f7ff',
                                        borderRadius: '8px',
                                        border: '1px solid #007bff',
                                        textAlign: 'center'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#007bff',
                                            marginBottom: '8px',
                                            fontWeight: '500',
                                            margin: '0',
                                            textAlign: 'left'
                                        }}>
                                            Konum
                                        </div>

                                        <div style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            color: '#2c3e50',
                                            textAlign: 'center'
                                        }}>
                                            <span>{selectedCount.warehouse_name}</span>
                                            <br />
                                            {selectedCount?.is_address_based === false ?
                                                selectedCount.zones.map(zone => zone.zone_name).join(', ') :
                                                selectedZone?.zone_name || ''}
                                            &nbsp;
                                            <br />
                                            {selectedCount?.is_address_based !== false ?
                                                (nextAddress ? `${nextAddress.address} (${nextAddress.capacity})` :
                                                    selectedAddress && !isLastAddress ? `${selectedAddress.coordinate}${selectedAddress.direction}-${selectedAddress.row_number} (${selectedAddress.capacity})` :
                                                        'Önerilecek sıra bitti') : ''}
                                        </div>
                                    </div>
                                )}

                                <div style={{ textAlign: 'center' }}>
                                    <div style={{
                                        padding: '0px',
                                        border: '1px dashed #007bff',
                                        borderRadius: '8px',
                                        marginBottom: '20px',
                                        backgroundColor: '#f8f9fa',
                                        textAlign: 'center',
                                        backgroundColor: 'rgb(248, 249, 250)'
                                    }}>
                                        <Input
                                            type="text"
                                            placeholder="Şase okutun veya yazın..."
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            onFocus={handleInputFocus}
                                            onBlur={handleInputBlur}
                                            onKeyPress={handleKeyPress}
                                            disabled={isProcessing}
                                            style={{
                                                textAlign: 'center',
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                padding: '12px',
                                                background: 'transparent',
                                                border: 'none',
                                                margin: '0',
                                                outline: 'none',
                                                opacity: isProcessing ? 0.6 : 1
                                            }}
                                        />

                                    </div>


                                    {/* Son başarılı okutma bilgisi */}
                                    {lastScannedChassis && (
                                        <div style={{
                                            marginTop: '10px',
                                            padding: '8px 12px',
                                            textAlign: 'center',
                                            marginBottom: '10px'
                                        }}>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#6c757d',
                                                fontStyle: 'italic',
                                                marginBottom: '4px'
                                            }}>
                                                Son başarılı okutma
                                            </div>
                                            <div style={{
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#333',
                                                animation: isChassisUpdated ? 'chassisUpdate 1s ease-in-out' : 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                {lastScannedChassis}
                                            </div>
                                        </div>
                                    )}
                                    <div className='button-group d-flex' style={{ gap: "3px" }}>
                                        {/* Adressiz sayımda "Sonraki Adrese" butonu gösterilmez */}
                                        {selectedCount?.is_address_based !== false && (
                                            <button
                                                color="danger"
                                                style={{ backgroundColor: "rgb(255 14 0)", border: "none", outline: "none", color: "white", padding: "6px", borderRadius: "5px", cursor: "pointer" }}
                                                className='btn w-50'
                                                onClick={handleGec}
                                                disabled={isProcessing}
                                            >
                                                <i class="fa fa-repeat mr-1" aria-hidden="true"></i>
                                                Sonraki Adres
                                            </button>
                                        )}
                                        <button
                                            color="success"
                                            style={{
                                                backgroundColor: "#28a745",
                                                border: "none",
                                                outline: "none",
                                                color: "white",
                                                padding: "5px",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                                width: selectedCount?.is_address_based === false ? "100%" : "50%"
                                            }}
                                            className='btn'
                                            onClick={handleBarkodEkle}
                                            disabled={!inputValue.trim() || isProcessing}
                                        >
                                            {isProcessing ? (
                                                <>
                                                    <i class="fa fa-spinner fa-spin mr-1" aria-hidden="true"></i>
                                                    İşleniyor...
                                                </>
                                            ) : (
                                                <>
                                                    <i class="fa fa-check mr-2" aria-hidden="true"></i>
                                                    Tamam
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>



            {/* Tekrarlı Okutma Modal'ı */}
            <Modal isOpen={isDuplicateModalOpen} toggle={handleDuplicateCancel} centered>
                <ModalHeader toggle={handleDuplicateCancel}>
                    <i className="fa fa-exclamation-triangle text-warning mr-2"></i>
                    Tekrarlı Okutma Uyarısı
                </ModalHeader>
                <ModalBody>
                    <p>Bu şase daha önce okutulmuştur. Tekrar okutmak istediğinize emin misiniz?</p>
                    {duplicateChassisInfo && (
                        <div style={{
                            padding: '10px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            marginTop: '10px'
                        }}>
                            <strong>Adres:</strong> {duplicateChassisInfo.address}<br />
                            <strong>Son Okutma:</strong> {moment.utc(duplicateChassisInfo.scanned_at).local().format('DD.MM.YYYY HH:mm:ss')}<br />
                            <strong>Okutan:</strong> {duplicateChassisInfo.scanned_by}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleDuplicateCancel}>
                        <i className="fa fa-times mr-2"></i>
                        İptal
                    </Button>
                    <Button color="warning" onClick={handleDuplicateConfirm}>
                        <i className="fa fa-check mr-2"></i>
                        Evet, Tekrar Okut
                    </Button>
                </ModalFooter>
            </Modal>

            <style jsx>{`
                .swal2-custom-popup {
                    border-radius: 12px !important;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
                    border: none !important;
                    padding: 20px !important;
                }
                .swal2-custom-confirm {
                    border-radius: 8px !important;
                    font-weight: 600 !important;
                    font-size: 14px !important;
                    padding: 12px 24px !important;
                    transition: all 0.3s ease !important;
                    border: none !important;
                    box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3) !important;
                }
                .swal2-custom-confirm:hover {
                    transform: translateY(-1px) !important;
                    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.4) !important;
                }
                .swal2-custom-confirm:focus {
                    outline: none !important;
                    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2) !important;
                }
            `}</style>
        </>
    );
};

export default SayimOkutmaEkrani;